import React from 'react'
import styled from 'styled-components'

import theme from '@app/ui/theme'

export type SizeType = 'small' | 'normal'
interface ContainerProps {
  className?: string
  children: React.ReactNode
  size?: SizeType
  noPadding?: boolean
}

// eslint-disable-next-line @typescript-eslint/member-delimiter-style
const StyledContainer = styled.div<{ size: SizeType; noPadding?: boolean }>`
  margin: 0 auto;
  max-width: ${({ theme, size }) => theme.container[size]};
  padding: 0 4.8rem;
  ${({ noPadding }) => noPadding && 'padding: 0;'}

  @media ${theme.device.laptopL} {
    padding: 0 2rem;
  }

  @media ${theme.device.laptop} {
    ${({ size }) => {
      if (size === 'small') {
        return 'padding: 0 14.4rem'
      }
      return 'padding: 0 2rem;'
    }}
  }

  @media ${theme.device.tablet} {
    padding: 0 2rem;
  }
`

export function Container({ children, className, size = 'normal', noPadding }: ContainerProps) {
  return (
    <StyledContainer noPadding={noPadding} size={size} className={className}>
      {children}
    </StyledContainer>
  )
}
